export default {
    state: {
        data: {
            activeTab: 'enter',
            reCaptchaToken: '',
            chooseEnter: 'email',
            btnValues: {
                registration: 'Зарегистрироваться',
                enter: 'Войти',
                codeSMS: 'Получить смс с кодом',
            },
        }
    },
    mutations: {
        ['personal/setData'] (store, payload) {
            try {
                store.data = {
                    activeTab: store.data.activeTab,
                    reCaptchaToken: store.data.reCaptchaToken,
                    btnValues: store.data.btnValues,
                    chooseEnter: store.data.chooseEnter,
                    ...payload,
                };
            } catch (err) {
                console.error(err);
            }
        },
        ['personal/updateData'] (store, payload) {
            try {
                store.data = {...store.data, [payload.name]: payload.data };
            } catch (err) {
                console.error(err);
            }
        },
        ['personal/setError'] (store, payload) {
            try {
                store.data = {
                    ...store.data,
                    errors: {
                        ...payload,
                    },
                };
            } catch (err) {
                console.error(err);
            }
        },
        ['personal/changeActiveTab'] (store, payload) {
            try {
                store.data = {
                    ...store.data,
                    activeTab: payload,
                };
                delete store.data.errors;
            } catch (err) {
                console.error(err);
            }
        },
        ['personal/clearState'] (store, payload) {
            try {
                store.data = {
                    ...store.data,
                    authInfo: {
                        ...store.data.authInfo,
                        errors: null,
                        showSMS: false
                    },
                    errors: null
                };
            } catch (err) {
                console.error(err);
            }
        },
        ['personal/setReCapchaToken'] (store, payload) {
            try {
                store.data = {
                    ...store.data,
                    reCaptchaToken: payload,
                };
            } catch (err) {
                console.error(err);
            }
        },
        ['personal/setEnter'] (store, payload) {
            store.data = {
                ...store.data,
                chooseEnter: payload,

            };
            delete store.data.errors;
            delete store.data.authInfo.errors;

            // commit('personal/clearState')
        }
    },
    actions: {
        async ['personal/loginByPhone'] ({ state , commit }, payload) {
            try {
                const { activeTab, reCaptchaToken, btnValues } = state.data;
                const { e, component, resend } = payload;
                const data = new FormData(e.target);
                const {path, data: {action, api, LANGUAGE_ID}} = state.data?.routes?.send_sms_code;

                const phone = data.get('USER_LOGIN')?.replace(/[+| |(|)]/g,'');

                data.append('action', action);
                data.append('api', api);
                data.append('LANGUAGE_ID', LANGUAGE_ID);
                data.append('authType', activeTab);
                // data.append('g-recaptcha-response', reCaptchaToken);

                data.set('USER_LOGIN', phone);
                data.append('phone_number', phone);

                const response = await axios.post(path, data);

                if (!resend) {
                    if (!response.error && !response.data.error && response.status === 200) {
                        component.$parent.$emit('close');
                        component.$DefModal.show({
                            name: 'sms-confirmation',
                            width: '440px',
                            props: {
                                activeTab,
                                btnValues,
                                e,
                                userPhoneNumber: data.get('USER_LOGIN'),
                                userName: data.get('USER_NAME'),
                                userLastName: data.get('USER_LAST_NAME'),
                            },
                        })
                        // component.$modal.show(App.getComponent('sms-confirmation'),
                        //     {
                        //         activeTab,
                        //         btnValues,
                        //         e,
                        //         userPhoneNumber: data.get('USER_LOGIN'),
                        //         userName: data.get('USER_NAME'),
                        //         userLastName: data.get('USER_LAST_NAME'),
                        //     },
                        //     {
                        //         height: 'auto',
                        //         width: '440px',
                        //         adaptive: true,
                        //     });
                    } else if (response.data.error) {
                        commit('personal/setError', { loginBuyPhone: response.data.error });
                    }
                } else {
                    return response;
                }

            } catch (err) {
                console.error(err);
            }
        },
        async ['personal/loginByEmail'] ({ state , commit }, payload){
            try {
                const e = payload;
                const { routes } = state.data
                const data = new FormData(e.target);
                const {path, data: {action, api, LANGUAGE_ID}} = routes?.auth;

                data.append('action', action);
                data.append('LANGUAGE_ID', LANGUAGE_ID);
                data.append('api', api);

                const response = await axios.post(path, data);

                if (response.status === 200 || response.statusText === 'OK') {
                    commit('personal/updateData', {name: 'authInputs', data: response.data.authInputs});
                    commit('personal/updateData', {name: 'authInfo', data: response.data.authInfo});
                }
                if (response.data.authInfo.status) {
                    location.reload();
                }

            } catch (err) {
                console.error(err)
            }
        },
        async ['personal/registerByEmail'] ({ state , commit }, payload) {
            try {
                const { e, component} = payload;
                const { actions, routes, reCaptchaToken } = state.data;
                const data = new FormData(e.target);
                const path = actions?.register;
                const {data: {action, api, LANGUAGE_ID}} = routes?.register;

                data.append('action', action);
                data.append('api', api);
                data.append('USER_LOGIN', data.get('USER_EMAIL'));
                data.append('g-recaptcha-response', reCaptchaToken);
                data.append('LANGUAGE_ID', LANGUAGE_ID);
                const response = await axios.post(path, data);

                if (response.status === 200) {
                    if (response.data.authInfo) {
                        commit('personal/updateData', {
                            name: 'regInputs',
                            data: response.data.regInputs
                        });
                        commit('personal/updateData', {name: 'authInfo', data: response.data.authInfo});
                    }
                    /**
                     * Вывод ошибки
                     */
                    commit('personal/updateData', {name: 'errors', data: {incorrectEmail: response.data.exceptionError} });

                    if (response.data.authInfo.status && response.data.authInfo.isAuthorized) {
                        component.$DefModal.hide();
                        location.reload();
                    }
                }
            } catch (err) {
                console.error(err)
            }
        },
        async ['personal/recaptcha'] ({ state , commit }, payload) {
            const { component } = payload;
            const { reCaptchaSiteKey } = state.data.authInfo;
            // (optional) Wait until recaptcha has been loaded.
            await component.$recaptchaLoaded()

            // Execute reCAPTCHA with action "login".
            const token = await component.$recaptcha(reCaptchaSiteKey)
            this.reCaptchaToken = token;

            commit('personal/setReCapchaToken', token);
            return token;
        },
    }
}